import { createContext } from 'react';
import Echo from '@ably/laravel-echo';

import { Nullable } from '../../types';
import {
  PrivateEchoPresenceWebsocketService,
  PrivateEchoWebsocketService,
  PublicEchoWebsocketService,
} from './services';

export type WebsocketContextValue = {
  publicWebsocketService: Nullable<PublicEchoWebsocketService>;
  privateWebsocketService: Nullable<PrivateEchoWebsocketService>;
  privatePresenceWebsocketService: Nullable<PrivateEchoPresenceWebsocketService>;
  connection: Nullable<Echo>;
};

export const WebsocketContext = createContext<WebsocketContextValue>({
  publicWebsocketService: null,
  privateWebsocketService: null,
  privatePresenceWebsocketService: null,
  connection: null,
});
